var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-image image-container noselect",class:{ failed: _vm.imageFailed }},[_c('img',{attrs:{"src":_vm.imageSource},on:{"error":_vm.picLoadError}})])}
var staticRenderFns = []

export { render, staticRenderFns }